import axios from 'axios'

const BASE_URL ='https://youtube-v31.p.rapidapi.com';
const options = {
    url: BASE_URL,
    params: {maxResults:'50'},
    headers: {
      'X-RapidAPI-Key': '4cb85ee635msh7a57466fefbca5dp1b67f1jsn9d4aead32905',
      'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    }
  };

  export const fetchFromAPI =async(url)=>{
    const {data} = await axios.get(`${BASE_URL}/${url}`,options);

    return data;
  } 